<div [formGroup]="formGroup" *ngIf="formGroup" class="w-full py-2">
  <div class="mb-1">
    <div class="flex flex-row">
      <label
        class="block text-2sm font-medium mb-1 text-gray-900 dark:text-gray-300"
        [for]="fields.fieldName"
        [ngClass]="{ required: fields.isRequired }"
      >
        {{ fields.displayName }}
      </label>
    </div>
    <input
      #focusInput
      [type]="fields.fieldType"
      [formControlName]="fields.fieldName"
      [placeholder]="fields?.placeholder"
      (keyup)="onKeyUpValidateFields(fields)"
      [id]="fields.fieldName"
      [attr.min]="
        fields.fieldType == 'number' ? getRuleValue(fields, 'min') : null
      "
      [attr.max]="
        fields.fieldType == 'number' ? getRuleValue(fields, 'max') : null
      "
      [disabled]="disableFields == true"
      class="input w-full border border-gray-300 rounded px-3 py-2 text-2sm dark:bg-gray-800 dark:text-white border dark:border-gray-700 text-gray-700 placeholder:text-gray-500 focus:outline-none focus:ring focus:ring-blue-200"
      [ngClass]="{
        'disable-field': disableFields == true,
        'border-danger':
          formGroup.get(fields.fieldName)?.touched &&
          formGroup.get(fields.fieldName)?.invalid,
      }"
    />
    <!-- Validation messages -->
    <div
      *ngIf="
        formGroup.get(fields.fieldName)?.touched &&
        formGroup.get(fields.fieldName)?.invalid
      "
      class="text-danger text-sm mt-1"
    >
      <ng-container
        *ngIf="
          formGroup.get(fields.fieldName)?.errors?.['required'];
          else otherErrors
        "
      >
        Please enter {{ fields.displayName }}
      </ng-container>
      <ng-template #otherErrors>
        {{ errors[fields.fieldName] }}
      </ng-template>
    </div>
  </div>
</div>
